module.exports = __webpack_public_path__ + "static/media/comforte_logo.bfc7309a.png";